const badgeCode = `<a href="https://policies.google.com/privacy">Privacy Policy</a>
<a href="https://policies.google.com/terms">Terms of Service</a>`;

export default badgeCode;
